<template>
  <div>
    <div
      class="flex items-center justify-between cursor-pointer rounded-full transition duration-150 ease-in-out hover:bg-[#FCFCFC] py-[4px]"
      @click="toggle"
    >
      <div class="flex items-center gap-[10px]">
        <div
          class="flex items-center justify-center rounded-full size-[44px] bg-[#FFEBE7] shrink-0 transition-colors"
          :class="{ '!bg-[#FFEDED]': hasError }"
        >
          <slot name="icon">
            <span
              v-if="icon"
              class="text-[24px] font-medium text-[#F95031]"
              :class="[icon, { '!text-[#E31A1A]': hasError }]"
            />
          </slot>
        </div>
        <div class="flex items-center gap-[10px] flex-wrap">
          <h4
            class="mb-0 font-medium text-[#000000]"
            :class="{ '!text-[#E31A1A]': hasError }"
          >
            <slot name="title">
              {{ title }}
            </slot>
          </h4>
          <span
            v-if="hasError"
            class="inline-flex items-center gap-[4px] px-[8px] py-[2px] rounded-full text-[12px] font-medium bg-[#FFEDED] text-[#E31A1A] border border-[#FFA8A8]"
          >
            <feather-icon
              icon="AlertCircleIcon"
              size="13"
              class="shrink-0"
            />
            <span>{{ errorCount ? `${errorCount} Error` : 'Error' }}</span>
          </span>
        </div>
      </div>
      <div
        class="transition-transform duration-200"
        :class="{ 'rotate-180': isVisible }"
      >
        <span
          class="k-arrow-down-1 text-[24px] font-medium"
          :class="hasError ? 'text-[#E31A1A]' : 'text-[#292D32]'"
        />
      </div>
    </div>

    <b-collapse
      ref="collapse"
      v-model="isVisible"
    >
      <slot />
    </b-collapse>
  </div>
</template>

<script>
import { BCollapse } from 'bootstrap-vue'

export default {
  name: 'Collapsible',
  components: {
    BCollapse,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    icon: {
      type: String,
      default: '',
    },
    visible: {
      type: Boolean,
      default: false,
    },
    hasError: {
      type: Boolean,
      default: false,
    },
    errorCount: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      isVisible: this.visible,
    }
  },

  watch: {
    visible(val) {
      this.isVisible = val
    },
    isVisible(val) {
      this.$emit('update:visible', val)
      this.$emit('change', val)
    },
  },
  methods: {
    toggle() {
      this.isVisible = !this.isVisible
    },
  },
}
</script>

<style scoped>
/* Custom transitions/rotations */
.rotate-180 {
  transform: rotate(180deg);
}
</style>
